import React, { useState } from "react";
import Button from "components/CustomButton";
import Scrollbar from "react-scrollbars-custom";
import { ReactComponent as List } from "assets/img/icons/list.svg";
import TeamTodoList from "views/Teams/TeamTodoList/TeamTodoList";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import "assets/scss/partials/microsoftTeams.scss";

export default () => {
  const [dialog, setDialog] = useState(false);
  const { setShowTodoListTeams } = useTeamActionContext();

  const openTodoListDialog = () => {
    setDialog(true);
    setShowTodoListTeams(true);
  };

  return (
    <>
      <Button
        buttonClass="invite-btn text-center microsoftTeamTodoListButton"
        onClick={openTodoListDialog}
      >
        <List style={{ fill: "white", width: "24px" }} />
        Todo List
      </Button>
      <Modal
        open={dialog}
        closeOnOverlayClick={false}
        onClose={() => setDialog(false)}
        showCloseIcon={false}
        center={true}
        classNames={{ modal: "microsoftTeamUserPollListDetail" }}
        closeOnEsc={false}
      >
        <div className="microsoftTeamsDialogHeader todoListMicrosoftTeamButton">
          {" "}
          TodoList
          <div className="closeMicrosoftTeamsDialog">
            <CloseIcon onClick={() => setDialog(false)} className="cursor" />
          </div>
        </div>
        <div className="todoListMicrosoftPadding">
          <Scrollbar style={{ height: "calc(100vh - 100px)" }}>
            <div>
              <div>
                <TeamTodoList />
              </div>
            </div>
          </Scrollbar>
        </div>
      </Modal>
    </>
  );
};
